import API from './config';

export function getAll() {
  return API.get('schools');
}

export function create(data: { name: string; }) {
  return API.post('schools', data);
}
